/**
 * Legacy: Marketo
 *
 * @link https://developers.marketo.com/javascript-api/forms/api-reference/
 *
 * @module legacy/LMarketo
 */


// Dependances
// ============================================================================

import { $ } from '../common/utility/u-jquery-$';
import { MRKTOEmails } from "../common/marketo/mrkto-emails.js";
import { MRKTOHelpers } from '../common/marketo/mrkto-helpers.js';
import { UCookies } from '../common/utility/u-cookies';


// Init
// ============================================================================

/**
 * Core module init
 *
 * @return  {void}
 */
function _moduleInit()
{
	init_marketo_forms_main_1();
	init_marketo_forms_main_2();
	init_marketo_forms_asset_auto_clicker();
	init_marketo_remove_placeholders();
}


// Main Func
// ============================================================================

function init_marketo_forms_main_1()
{
	if ($(".form form")[0])
	{
		if (!$(".form-slider").length)
		{
			// No Form Slider
			// ====================================================================

			$(".form form").each(function ( i, el )
			{
				const $formEl = $( el );

				// Form ID/attributes
				var formID   = $(this).attr("data-id");
				var siteURL  = $(this).attr("data-theme");
				var formURL  = $(this).attr("data-url");
				var formPost = $(this).attr("data-post");
				var formTY   = $(this).attr("data-thankyou");

				if (typeof MktoForms2 !== "object")
				{
					console.warn("[ON24] MktoForms2 is referenced in app/marketo.js, but was not defined at the time of execution");
					return;
				}

				// Loads a Marketo form (via MktoForms2.loadForm), but with
				// special protections so it only loads once. Besides this, it's
				// just a wrapper for:
				//   MktoForms2.loadForm("https://communications.on24.com", "848-AHN-047", formID, callback)
				MRKTOHelpers.loadMarketoFormOnce( formID, function( form )
				{
					// Seems like this is intended to remove the default Marketo classes
					$formEl.removeClass().removeAttr("style");

					form.onSuccess(function (values, followUpUrl)
					{
						if (typeof fbq != "undefined")
						{
							fbq("track", "Lead");
						}

						// CookieSave:1 = No form slider
						onSuccess_saveCookie( formID );

						// @TODO: Not sure what this does, there's no `.cookie-set` in the codebase. It WAS in the
						// original theme code from Croc, but it was in files that have since been deleted.
						if ($(".cookie-set")[0])
						{
							jQuery.ajax({
								type: "POST",
								url: siteURL + "/library/setAssetCookie.php",
								data: {
									assetId: formPost,
								},
								success: function (data)
								{
									if ($(".asset-signpost").hasClass("webinar"))
									{
										window.dataLayer = window.dataLayer || [];
										window.dataLayer.push(
											{ event: "webinarLeadForm", },
											{ event: "leadform", eventCallback: function () { window.location = formTY; }, }
										);
									}
									else if ($(".asset-signpost")[0])
									{
										window.dataLayer = window.dataLayer || [];
										window.dataLayer.push(
											{ event: "assetLeadForm", },
											{ event: "leadform", eventCallback: function () { window.location = formTY; }, }
										);
									}
									else
									{
										window.dataLayer = window.dataLayer || [];
										window.dataLayer.push(
											{ event: "leadform", eventCallback: function () { window.location = formTY; }, }
										);
									}

									setTimeout(function ()
									{
										// @note: Atm this will trigger for EVERY form on a page.
										// This issue was fixed in c-marketo.js
										// Code: NOTE_AUTO_ASS
										var aa = $("body").find("#auto_asset");

										if (aa.length)
										{
											aa[0].click();
										}
									}, 500);
								},
							});

							return false;
							// end:.cookie-set
						}
						else if ($(".webinar-redirect")[0])
						{
							if ($(".asset-signpost").hasClass("webinar"))
							{
								window.dataLayer = window.dataLayer || [];
								window.dataLayer.push({ event: "webinarLeadForm" }, { event: "leadform" });
							}
							else if ($(".asset-signpost")[0])
							{
								window.dataLayer = window.dataLayer || [];
								window.dataLayer.push({ event: "assetLeadForm", }, { event: "leadform", });
							}
							else
							{
								window.dataLayer = window.dataLayer || [];
								window.dataLayer.push({ event: "leadform", });
							}

							var location_url = $(".webinar-redirect").attr("data-url");

							location.href = location_url;

							return false;
						}
						else if ($("form.url-confirmation-form")[0])
						{
							if ($(".asset-signpost").hasClass("webinar"))
							{
								window.dataLayer = window.dataLayer || [];
								window.dataLayer.push({ event: "webinarLeadForm", }, { event: "leadform", });
							}
							else if ($(".asset-signpost")[0])
							{
								window.dataLayer = window.dataLayer || [];
								window.dataLayer.push({ event: "assetLeadForm", }, { event: "leadform", });
							}
							else
							{
								window.dataLayer = window.dataLayer || [];
								window.dataLayer.push({ event: "leadform", });
							}

							form.getFormElem().hide();
							$(".form-2020 .form").hide();
							$(".thankyou").show();
							mkFormHeadingToggle();

							$("html, body").animate({ scrollTop: $(".thankyou").offset().top - 150, }, 1000);

							setTimeout(function ()
							{
								// @note: See `NOTE_AUTO_ASS` above
								var aa = $("body").find("#auto_asset");

								if (aa.length)
								{
									aa[0].click();
								}

								var formURL = $(".form form").attr("data-url");
								window.open(formURL, "_blank");
							}, 500);

							return false;
						}
						else
						{
							if ($(".asset-signpost").hasClass("webinar"))
							{
								window.dataLayer = window.dataLayer || [];
								window.dataLayer.push({ event: "webinarLeadForm", }, { event: "leadform", });
							}
							else if ($(".asset-signpost")[0])
							{
								window.dataLayer = window.dataLayer || [];
								window.dataLayer.push({ event: "assetLeadForm", }, { event: "leadform", });
							}
							else
							{
								window.dataLayer = window.dataLayer || [];

								switch (formID)
								{
									case "325": window.dataLayer.push({ event: "freeTrialLeadForm", }); break;     // ATOW: Used on PRD 1 time
									case "1412": window.dataLayer.push({ event: "liveDemoLeadForm", }); break;     // ATOW: Used on PRD 1 time
									case "1463": window.dataLayer.push({ event: "contactLeadForm", }); break;      // ATOW: Used on PRD 4 times
									case "3814": window.dataLayer.push({ event: "requestQuoteLeadForm", }); break; // ATOW: Used on PRD 48 times
									default: window.dataLayer.push({ event: "leadform", });
								}
							}

							form.getFormElem().hide();
							$(".form-2020 .form").hide();
							$(".thankyou").show();
							mkFormHeadingToggle();

							setTimeout(function ()
							{
								// @note: See `NOTE_AUTO_ASS` above
								var aa = $("body").find("#auto_asset");

								if (aa.length)
								{
									aa[0].click();
								}
							}, 500);

							$("html, body").animate({ scrollTop: $(".thankyou").offset().top - 150, }, 1000);

							return false;
						}
					});
				});
			});

			if (typeof MktoForms2 !== "object")
			{
				console.warn("[ON24] MktoForms2 is referenced in app/marketo.js, but was not defined at the time of execution");
			}
			else
			{
				MktoForms2.onFormRender(function ()
				{
					$('.mktoLabel[for="PostalCode"]').addClass("hide");
					$(".mktoCheckboxList").parent().addClass("mktoCheckbox");
				});
			}
			// end: does NOT have .form-slider
		}
		else if ($(".form-slider").length)
		{
			// Has Form Slider
			// ====================================================================

			if (typeof MktoForms2 !== "object")
			{
				console.warn("[ON24] MktoForms2 is referenced in app/marketo.js, but was not defined at the time of execution");
			}
			else
			{
				$(".form form").each(function ()
				{
					var formID = $(this).attr("data-id");

					MktoForms2.loadForm("https://communications.on24.com", "848-AHN-047", formID, function (form)
					{
						$(".form form").removeClass().removeAttr("style");

						form.onSuccess(function (values, followUpUrl)
						{
							// CookieSave:1 = Has form slider
							onSuccess_saveCookie( formID );

							// Get the form's jQuery element and hide it
							if (typeof fbq != "undefined") fbq("track", "Lead");
							form.getFormElem().parent().hide();
							form.getFormElem().parent().parent().find(".thankyou").show();
							$("html, body").animate(
								{ scrollTop: form.getFormElem().parent().parent().find(".thankyou").offset().top - 150 },
								1000
							);
							return false;
						});
					});
				});

				MktoForms2.onFormRender(function ()
				{
					$('.mktoLabel[for="PostalCode"]').addClass("hide");
					$(".mktoCheckboxList").parent().addClass("mktoCheckbox");

					// add slider
					if ($(".form-slider")[0])
					{
						$(".form-slider").slick({
							arrows: false,
							autoplay: false,
							dots: false,
							adaptiveHeight: true,
							draggable: false,
						});

						$(".form-slider").on("init", function (event, slick)
						{
							if (window.location.hash.indexOf("form") == 1)
							{
								var hash = window.location.hash.substr(1);
								var slideno = $("#" + hash).attr("data-slick-index");

								$(".form-slider").slick("slickGoTo", slideno);

								$(".form-slider-tabs .card-wrap").removeClass("active");
								$('.form-slider-tabs .card-wrap[data-id="' + slideno + '"]').addClass("active");

								$("html, body").animate({ scrollTop: $(".form-slider").offset().top - 120, }, "slow");
							}
							$(".form-slider").addClass("initialised");
						});
					}
				});

				MktoForms2.whenRendered(function (form)
				{
					var formEl = form.getFormElem()[0];
					var rando = "_" + Math.random();

					[].slice.call(formEl.querySelectorAll("label[for]")).forEach(function (labelEl)
					{
						var forEl = formEl.querySelector('[id="' + labelEl.htmlFor + '"]');
						labelEl.htmlFor = forEl.id = forEl.id + rando;
					});
				});
			}
			// end: has .form-slider
		}

		//Tweaking Page Title on form submission.
		MktoForms2.whenReady(function (form)
		{
			var pageTitle = document.title;
			form.onSuccess(function (values, followUpUrl)
			{
				document.title = 'Form successful | ' + pageTitle;
				return false; // Prevents the form from redirecting to the follow-up URL
			});

			// Causes error not sure why 25/05/2023
			// form.onInvalid(function() {
			//     document.title = 'Form unsuccessful | ' + pageTitle;
			// });
		});
	}
}


// Sub-Funcs
// ============================================================================

function init_marketo_forms_main_2()
{
	if (typeof MktoForms2 !== "object")
	{
		console.warn("[ON24] MktoForms2 is referenced in app/marketo.js, but was not defined at the time of execution");
	}
	else
	{
		if ($("body").hasClass("page-id-46316") || $("body").hasClass("postid-72810") || $("body").hasClass("postid-72543") || $("body").hasClass("page-id-42175") || $(".submitAnyEmail").length)
		{
			MktoForms2.whenReady(function (form)
			{
				var errorFreemail = "Please use a business or company email address."; /* no need to touch below this line */
				var formEl = form.getFormElem()[0];
				var emailEl = formEl.querySelector("input[name='Email']");
				var emailJq = MktoForms2.$(emailEl);
				var errorEl = $('<div class="business-email-error">' + errorFreemail + "</div>");

				errorEl.insertAfter(emailEl);

				$(emailEl).on("keyup blur", function ()
				{
					var currentEmail = $(this).val();

					if ( MRKTOEmails.isEmailAddressFree( currentEmail, true ) )
					{
						form.submittable(false);
						errorEl.addClass("show");
						$(emailEl).addClass("mktoInvalid");
					}
					else
					{
						errorEl.removeClass("show");
						$(emailEl).removeClass("mktoInvalid");
						form.submittable(true);
					}
				});

				form.onSuccess(function (values, followUpUrl)
				{
					if (typeof fbq != "undefined") fbq("track", "Lead");
				});

				form.onValidate(function (native)
				{
					if ($(".form-slider")[0])
					{
						$(".form-slider").slick("resize");
					}

					// if (!native) return;

					var currentValues = form.getValues();
					var currentEmail = currentValues.Email;

					if ( MRKTOEmails.isEmailAddressFree( currentEmail, true ) )
					{
						form.submittable(false);
						errorEl.addClass("show");
						$(emailEl).addClass("mktoInvalid");
					}
					else
					{
						errorEl.removeClass("show");
						form.submittable(true);
						$(emailEl).removeClass("mktoInvalid");
					}
				});
			});
		}
		else
		{
			MktoForms2.whenReady(function (form)
			{
				var errorFreemail = "Please use a business or company email address.";
				var formEl = form.getFormElem()[0];
				var emailEl = formEl.querySelector("input[name='Email']");
				var emailJq = MktoForms2.$(emailEl);

				var errorEl = $('<div class="business-email-error">' + errorFreemail + "</div>");
				errorEl.insertAfter(emailEl);

				// @TODO: Use Marketo's own validation message API instead?
				// https://developers.marketo.com/javascript-api/forms/api-reference/
				// Eg:
				//form.showErrorMessage('ERROR MESSAGE', $( emailEl ));

				$(emailEl).on("keyup blur", function ()
				{
					var currentEmail = $(this).val();

					if ( MRKTOEmails.isEmailAddressFree( currentEmail ) )
					{
						form.submittable(false);
						errorEl.addClass("show");
						$(emailEl).addClass("mktoInvalid");
					}
					else
					{
						errorEl.removeClass("show");
						$(emailEl).removeClass("mktoInvalid");
						form.submittable(true);
					}
				});

				form.onSuccess(function (values, followUpUrl)
				{
					if (typeof fbq != "undefined") fbq("track", "Lead");
				});

				form.onValidate(function (native)
				{
					if ($(".form-slider")[0])
					{
						$(".form-slider").slick("resize");
					}

					// if (!native) return;

					var currentValues = form.getValues();
					var currentEmail = currentValues.Email;

					if ( MRKTOEmails.isEmailAddressFree( currentEmail ) )
					{
						form.submittable(false);
						errorEl.addClass("show");
						$(emailEl).addClass("mktoInvalid");
					}
					else
					{
						errorEl.removeClass("show");
						$(emailEl).removeClass("mktoInvalid");
						form.submittable(true);
					}
				});
			});
		}
	}
}


/**
 * Asset Auto-Clicker
 *
 * @return  {void}
 */
function init_marketo_forms_asset_auto_clicker()
{
	// Auto-trigger click on asset if user doesn't click within 4000 seconds.
	$("body").find("#asset_click_here").click(function ()
	{
		if ($(this).hasClass("unclicked"))
		{
			$(this).removeClass("unclicked");
		}
	});

	setTimeout(function ()
	{
		if ($("body").find("#asset_click_here.unclicked").length)
		{
			$("body").find("#asset_click_here").attr("target", "")[0].click();
		}
	}, 4000);
}


/**
 * Remove Placeholders
 *
 * @return  {void}
 */
function init_marketo_remove_placeholders()
{
	if (typeof MktoForms2 !== "object")
	{
		console.warn("[ON24] MktoForms2 is referenced in app/marketo.js, but was not defined at the time of execution");
	}
	else
	{
		MktoForms2.onFormRender(function (form)
		{
			var formEl = $(form.getFormElem()[0]);
			var targets = formEl.find(".mktoFormRow.mktoPlaceholder");

			if (targets.length)
			{
				targets.each(function ()
				{
					var _ = $(this);

					if (_.children().length)
					{
						_.removeClass("mktoPlaceholder");
					}
				});
			}
		});
	}
}


// Helpers
// ============================================================================

/**
 * Form Heading Toggle
 *
 * On form submission, hides the regular title and shows the optional one
 * (if set in the CMS)
 *
 * @since 678
 * @link https://in-beta.codebasehq.com/projects/on24-support/tickets/678
 *
 * @return  {void}
 */
function mkFormHeadingToggle()
{
	var $submitHide = $( '[data-mkform-onsubmit="hide"]' );
	var $submitShow = $( '[data-mkform-onsubmit="show"]' );

	if ( $submitHide.length && $submitShow.length )
	{
		$submitHide.hide();
		$submitShow.show();

		$submitHide.removeClass( 'is-active' );
		$submitHide.addClass( 'is-hidden' );
		$submitShow.addClass( 'is-active' );
	}
}


// V3 (Backported)
// ============================================================================

/**
 * !IMPORTANT!
 * This method is taken from: c-marketo.js
 *
 * Please view it there for more details. It's been copied here so its cookie
 * can be saved to the old asset posts, which don't use the Marketo Component.
 *
 * Like the original method from c-marketo, this method also triggers via
 * Marketo API's `.onSuccess` method, above.
 *
 * @since 951
 * @link  https://in-beta.codebasehq.com/projects/on24-support/tickets/951
 *
 * @return  {void}
 */
function onSuccess_saveCookie( formID )
{
	const cookieName = `on24-savedform-${formID}`;
	const cookieVal  = window.location.href;
	const debugLog   = true;

	if ( debugLog )
	{
		console.info( '[l-marketo] Saved cookie', { cookieName, cookieVal } );
	}

	// Set the form cookie
	UCookies.setCookie( cookieName, cookieVal, 0 );

	// Set a special cookie that disables the Kinsta cache, if the user
	// has this cookie set in their browser. This is needed because
	// otherwise, the Kinsta cache prevents us from accessing $_COOKIE
	// later (eg. in `marketo_required_form_redirect`)
	UCookies.setCookie( 'kinsta-disable-cache', 1, 0 );

	// New, Added in 977 V3 Modals - Set for 2 weeks.
	// If the User has submitted ANY forms on the website then we won't to avoid them seeing Modals
	// Can be overridden with an ACF field so that a modal takes priority over this cookie.
	UCookies.setCookie('bypass_modals', 1, 14);
}


// Auto Init
// ============================================================================

$( document ).ready( () => _moduleInit() );
